import { DatePicker } from 'antd'
import { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import { Dispatch } from 'react'

import { dayMonthYearFormatWithDot } from 'src/libs'

type Props = {
  setDateTo: Dispatch<string>
  setDateFrom: Dispatch<string>
  resetPagination?: () => void
} & RangePickerProps

const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  return current && current > dayjs().endOf('day')
}

export const RangePicker = ({
  setDateFrom,
  setDateTo,
  resetPagination,
  ...props
}: Props) => {
  const onRangeChange = (dateStrings: string[]) => {
    if (dateStrings) {
      setDateFrom(dateStrings[0])
      setDateTo(dateStrings[1])
    }
    resetPagination?.()
  }

  return (
    <DatePicker.RangePicker
      format={dayMonthYearFormatWithDot}
      placement="bottomRight"
      disabledDate={disabledDate}
      onChange={(_, datesString) => onRangeChange(datesString)}
      {...props}
    />
  )
}
